export default __webpack_public_path__ + "static/media/headphone-controller-app-circle.b0125d6b.png";